import React from 'react';

function AnimationAboutHeaderText({children}) {
    return (
        <div className="AnimationAboutHeaderText">{children}</div>
    );
}

export default AnimationAboutHeaderText;
